import { getChargebackById } from "@/services/disputes.service";
import { useQuery } from "@tanstack/react-query";

export const useChargeback = (id, options = {}) => {
  return useQuery({
    queryKey: ["chargeback", id],
    queryFn: () => getChargebackById(id),
    enabled: Boolean(id),
    select: (res) => res?.data,
    ...options,
  });
};
